/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Every result is reduced to lowest terms by dividing the numerator and denominator by their greatest common divisor.`)
};

const es_fr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Todos los resultados se reducen a su mínima expresión dividiendo el numerador y el denominador entre su máximo común divisor.`)
};

const de_fr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Jedes Ergebnis wird auf die einfachste Form gekürzt, indem Zähler und Nenner durch ihren größten gemeinsamen Teiler geteilt werden.`)
};

const nl_fr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Elk resultaat wordt herleid tot de kleinste termen door teller en noemer door hun grootste gemene deler te delen.`)
};

const fr_fr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Chaque résultat est réduit à sa forme la plus simple en divisant le numérateur et le dénominateur par leur plus grand diviseur commun.`)
};

const it_fr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Ogni risultato viene ridotto ai minimi termini dividendo numeratore e denominatore per il loro massimo comun divisore.`)
};

const pt_br2_fr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Todo resultado é reduzido à forma mais simples dividindo o numerador e o denominador pelo maior divisor comum.`)
};

const pt_fr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Todos os resultados são reduzidos aos termos mais simples, dividindo o numerador e o denominador pelo seu máximo divisor comum.`)
};

const ja_fr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。すべての結果は分子と分母を最大公約数で割ることで、最も簡単な形に約分されます。`)
};

const zh_fr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会的。每个结果都会通过除以分子和分母的最大公约数化简为最简形式。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_faq_a3", locale)
	if (locale === "en") return en_fr_faq_a3(inputs)
	if (locale === "es") return es_fr_faq_a3(inputs)
	if (locale === "de") return de_fr_faq_a3(inputs)
	if (locale === "nl") return nl_fr_faq_a3(inputs)
	if (locale === "fr") return fr_fr_faq_a3(inputs)
	if (locale === "it") return it_fr_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_fr_faq_a3(inputs)
	if (locale === "pt") return pt_fr_faq_a3(inputs)
	if (locale === "ja") return ja_fr_faq_a3(inputs)
	return zh_fr_faq_a3(inputs)
};